import { 
    Title,
    Subtitle,
    ArticleContainer,
    StayInformedContainer,
    FirstBox,
    ImgArrow
} from './style'
import React  from 'react';
import longArrow from '../../image/longArrow.png'
import { NewsCardComponent } from '../newscard/component';
import { useState, useEffect } from 'react';
import { getAllArticles } from '../../api';

export const StayInformedComponent = () => {

    const [article, setArticle] = useState([]);
    
    useEffect(async() => {
        const data = await getAllArticles();
        setArticle(data.data.data.data);
    }, []);

    return (
        <StayInformedContainer>
            <FirstBox>
                <Title>STAY INFORMED</Title>
                <div>
                    <ImgArrow 
                        src={longArrow} 
                        alt="" 
                    />
                </div>
                <Subtitle>WITH OUR</Subtitle>
                <Subtitle>LEGAL INSIGHTS</Subtitle>
            </FirstBox>
            <ArticleContainer>
                {article.length > 0 && article.slice(0, 3).map((row) => (
                    <NewsCardComponent 
                        title={row.title}
                        description={row.body}
                        created_at={row.created_at}
                        bg={row.thumbnail_path}
                        path={"article/" + row.id}
                    />
                ))}
            </ArticleContainer>
        </StayInformedContainer>
    )
}